import { RootState, _ } from "common";
import { createSelector } from "reselect";

const selectUserAffiliateState = (state: RootState) => state.PcWorthCare;

const selectUserAffiliateVouchers = createSelector(
  selectUserAffiliateState,
  (state) => state.userRma
);

const selectIsUserRmasLoading = createSelector(
  selectUserAffiliateState,
  (state) => state.isUserRmasLoading
);

const selectIsRmaDetailsLoading = createSelector(
  selectUserAffiliateState,
  (state) => state.isUserRmaDetailsLoading
);

const selectUserRmaDetails = createSelector(
  selectUserAffiliateState,
  (state) => state.getUserRmaResponse
);

const selectGetUserRmaPayload = createSelector(
  selectUserAffiliateState,
  (state) => state.getUserRmaPayload
);

export const selectors = {
  selectUserAffiliateVouchers,
  selectGetUserRmaPayload,
  selectUserRmaDetails,
  selectIsUserRmasLoading,
  selectIsRmaDetailsLoading,
};
